module.exports = __webpack_public_path__ + "img/XY.d8c06272.png";